import styled from "styled-components";

export const Section = styled.div`
  position: relative;
  height: 200vh;
  width: 100%;
`;
